export const LINEAGE_PARTS = {
  GROUP_PANEL: 'GROUP_PANEL',
  CLIPBOARD_BUTTON: 'CLIPBOARD_BUTTON',
  OVERVIEW_BUTTON: 'OVERVIEW_BUTTON',
  NODE_LOGO_NAME: 'NODE_LOGO',
  NODE_HEADER_NAME: 'NODE_HEADER',
  NODE_BACKGROUND_NAME: 'NODE_BACKGROUND',
  NODE_STATUS: 'NODE_STATUS',
  NODE_COLUMNS_NUMBER: 'NODE_COLUMNS_NUMBER',
  SHOW_COLUMNS_BUTTON: 'SHOW_COLUMNS_BUTTON',
  SHOW_TABLE_BUTTON: 'SHOW_TABLE_BUTTON',
  GROUP_LOGO_NAME: 'NODE_LOGO',
  GROUP_HEADER_NAME: 'NODE_HEADER',
  GROUP_BACKGROUND_NAME: 'GROUP_BACKGROUND',
};

export const CLICKABLE_NODE_PARTS = [
  LINEAGE_PARTS.NODE_BACKGROUND_NAME,
  LINEAGE_PARTS.NODE_HEADER_NAME,
  LINEAGE_PARTS.NODE_LOGO_NAME,
  LINEAGE_PARTS.GROUP_BACKGROUND_NAME,
  LINEAGE_PARTS.GROUP_HEADER_NAME,
  LINEAGE_PARTS.GROUP_LOGO_NAME,
  LINEAGE_PARTS.NODE_STATUS,
];
